"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkForDamage = void 0;
var checkForDamage = function (inputString) {
    var regex = /не найден/i;
    if (regex.test(inputString)) {
        return 'Повреждения не найдены';
    }
    return 'Есть повреждения';
};
exports.checkForDamage = checkForDamage;
